import { crunchSrcSet } from './utils'
import { PhotoProps } from '../../../shared/Module'
import { MouseEventHandler } from 'react'

interface ThumbProps extends PhotoProps {
  active?: boolean
  alt?: string
  onClick?: MouseEventHandler<HTMLButtonElement>
}

const Thumb = ({
  active,
  alt,
  fallbackURL,
  onClick,
  sizes,
  srcset: initialSrcset,
}: ThumbProps) => {
  const srcset = crunchSrcSet(initialSrcset)
  return (
    <button
      className={`c-glide__thumbnail${active ? ' is-active' : ''}`}
      onClick={onClick}
    >
      <img src={fallbackURL} srcSet={srcset} sizes={sizes} alt={alt} />
    </button>
  )
}

export default Thumb
